export const PRIMARY_COLOR = '#00aec3'

export const SECONDARY_COLOR = '#838383'
